module.exports = __webpack_public_path__ + "img/modelo-cantina-gal-5.98b770ea.jpg";